module.exports = __webpack_public_path__ + "static/media/cover.0c6d2cbb.jpg";